import styled from "@emotion/styled";

/** The TT-Norms font does not appear perfectly centered in the avatar circle. Some padding is necessary to shift the letters down. */
export const Initials = styled("span")`
    padding-top: 0.1em;
`;
